export const DOCUMENT_LINK =
  'https://support.easyship.com/hc/en-us/articles/21589036468242-Identity-Verification-KYC';
export const SUPPORT_LINK = 'https://app.easyship.com/help';
export const SESSION_STORAGE_KEY = 'hasVerificationModalShown';
export const DIRECT_PRINT_SUPPORT_LINK =
  'https://support.easyship.com/hc/en-us/articles/25442255287698-How-to-Select-Printing-Options-for-Your-Store';
